import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';

FormItem.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.string,
  layout: PropTypes.object,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

FormItem.defaultProps = {
  label: '',
  required: false,
  error: '',
};

function FormItem(props) {
  const { label, error, required, layout, children, ...rest } = props;
  return (
    <Form.Item
      {...rest}
      colon={false}
      label={label}
      required={required}
      validateStatus={error ? 'error' : null}
      help={error}
      layout={layout}
    >
      {children}
    </Form.Item>
  );
}

export default FormItem;



// WEBPACK FOOTER //
// ./src/components/BaseForm/components/FormItem.js